import React from "react";

// Ilustración del login: recorrido con puntos de control de tiempo.
// Contenido 100% decorativo y estático. Los ids de <pattern>/<mask> llevan
// prefijo por variante porque desktop y móvil conviven en el DOM.

const PIN_PATH = "M30 0C13.4 0 0 13.4 0 30c0 21 30 50 30 50s30-29 30-50C60 13.4 46.6 0 30 0z";

export const LoginPin = ({ id, width = 30, height = 41 }) => (
  <svg aria-hidden="true" width={width} height={height} viewBox="0 0 60 82">
    <defs>
      <pattern id={`${id}-dots`} width="6" height="6" patternUnits="userSpaceOnUse">
        <circle cx="3" cy="3" r="2.1" fill="#ffc701" />
      </pattern>
      <mask id={`${id}-mask`} maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="82">
        <path d={PIN_PATH} fill="#fff" />
        <circle cx="30" cy="29" r="10" fill="#000" />
      </mask>
    </defs>
    <rect width="60" height="82" fill={`url(#${id}-dots)`} mask={`url(#${id}-mask)`} />
  </svg>
);

const Check = ({ x, y, s = 1, stroke = "#101113", w = 2.6 }) => (
  <path
    d={`M${x - 6 * s} ${y} l${4 * s} ${4 * s} l${8 * s} ${-9 * s}`}
    fill="none" stroke={stroke} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round"
  />
);

export const LoginArtDesktop = () => (
  <div className="ggt-login__art-desktop d-none d-lg-block">
    <svg aria-hidden="true" viewBox="0 0 800 900" preserveAspectRatio="xMidYMid slice" className="ggt-login__svg">
      <defs>
        <pattern id="ggt-d-dots" width="12" height="12" patternUnits="userSpaceOnUse"><circle cx="6" cy="6" r="2" fill="#363940" /></pattern>
        <pattern id="ggt-d-grid" width="24" height="24" patternUnits="userSpaceOnUse"><circle cx="12" cy="12" r="1" fill="#24262b" /></pattern>
        <pattern id="ggt-d-dotsY" width="6" height="6" patternUnits="userSpaceOnUse"><circle cx="3" cy="3" r="1.9" fill="#ffc701" /></pattern>
        <pattern id="ggt-d-blocks" width="130" height="120" patternUnits="userSpaceOnUse"><rect x="0" y="0" width="104" height="96" rx="6" fill="#fff" /></pattern>
        <mask id="ggt-d-city" maskUnits="userSpaceOnUse" x="0" y="0" width="800" height="900">
          <rect width="800" height="900" fill="url(#ggt-d-blocks)" />
        </mask>
        <mask id="ggt-d-pin" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="82">
          <path d={PIN_PATH} fill="#fff" />
          <circle cx="30" cy="29" r="10" fill="#000" />
        </mask>
      </defs>
      <rect width="800" height="900" fill="url(#ggt-d-grid)" />
      <rect width="800" height="900" fill="url(#ggt-d-dots)" mask="url(#ggt-d-city)" />

      <path d="M507 430 V468 H637 V228" fill="none" stroke="#5b5f68" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0 14" />
      <path className="ggt-march ggt-march--lg" d="M117 468 H247 V228 H507 V430" fill="none" stroke="#ffc701" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0 14" />
      <path d="M507 300 V396" fill="none" stroke="#ff5a36" strokeWidth="7" strokeLinecap="round" strokeDasharray="0 14" />

      <g>
        <circle cx="117" cy="468" r="13" fill="#ffc701" />
        <Check x={117} y={468} />
        <circle cx="247" cy="348" r="13" fill="#ffc701" />
        <Check x={247} y={348} />
        <circle cx="377" cy="228" r="13" fill="#ffc701" />
        <Check x={377} y={228} />
        <circle className="ggt-pulse" cx="507" cy="348" r="28" fill="none" stroke="#ff5a36" strokeWidth="3" strokeDasharray="0 9" strokeLinecap="round" />
        <circle cx="507" cy="348" r="13" fill="#ff5a36" />
        <Check x={507} y={348} stroke="#ffffff" />
        <circle cx="637" cy="468" r="13" fill="#101113" stroke="#8b8e96" strokeWidth="3" strokeDasharray="0 6" strokeLinecap="round" />
      </g>

      <circle cx="507" cy="430" r="22" fill="#f1f1f2" opacity=".14" />
      <circle cx="507" cy="430" r="9" fill="#f1f1f2" />
      <circle cx="507" cy="430" r="3.5" fill="#101113" />

      <circle className="ggt-pulse" cx="637" cy="232" r="34" fill="none" stroke="#ffc701" strokeWidth="3" strokeDasharray="0 10" strokeLinecap="round" />
      <g transform="translate(607 150)"><rect width="60" height="82" fill="url(#ggt-d-dotsY)" mask="url(#ggt-d-pin)" /></g>

      <g fontFamily="Doto, monospace" fontWeight="700" letterSpacing="1" fontSize="14">
        <rect x="64" y="492" width="150" height="30" rx="15" fill="#1f1b0c" stroke="#6b5600" />
        <text x="80" y="512" fill="#ffe17a">SALIDA · 08:00</text>

        <rect x="92" y="333" width="136" height="30" rx="15" fill="#1f1b0c" stroke="#6b5600" />
        <text x="108" y="353" fill="#ffe17a">P1 · 08:24</text>

        <rect x="309" y="174" width="136" height="30" rx="15" fill="#1f1b0c" stroke="#6b5600" />
        <text x="325" y="194" fill="#ffe17a">P2 · 08:51</text>

        <rect x="290" y="333" width="196" height="30" rx="15" fill="#2a1612" stroke="#7a2e1f" />
        <circle className="ggt-blink" cx="306" cy="348" r="4" fill="#ff5a36" />
        <text x="318" y="353" fill="#ffb4a3">P3 · 09:32 +12'</text>

        <text x="486" y="435" fontSize="13" fill="#d4d5d8" textAnchor="end">UNIDAD 12</text>

        <rect x="560" y="492" width="166" height="30" rx="15" fill="#18191c" stroke="#3a3c42" strokeDasharray="3 4" />
        <text x="576" y="512" fill="#b4b6bc">P4 · ETA 09:58</text>

        <rect x="532" y="104" width="210" height="30" rx="15" fill="#ffc701" />
        <text x="548" y="124" fill="#101113">DESTINO · ETA 10:20</text>
      </g>
    </svg>

    <div className="ggt-login__art-top ggt-doto">
      <span style={{ color: "#d4d5d8" }}>RUTA 214 · 6 PUNTOS DE CONTROL</span>
      <span style={{ color: "#9a9ca3" }}>N 19.4326° · W 99.1332°</span>
    </div>

    <div className="ggt-login__art-bottom">
      <h2 className="ggt-login__headline ggt-doto">
        CADA PARADA,<br />A TIEMPO<span style={{ color: "#ffc701" }}>_</span>
      </h2>
      <p className="ggt-login__lead">Registra llegadas y tiempos en cada punto de control del recorrido.</p>
      <div className="ggt-login__strip">
        <div className="ggt-login__checks">
          <span className="ggt-dot ggt-dot--ok" /><span className="ggt-link ggt-link--ok" />
          <span className="ggt-dot ggt-dot--ok" /><span className="ggt-link ggt-link--ok" />
          <span className="ggt-dot ggt-dot--ok" /><span className="ggt-link ggt-link--ok" />
          <span className="ggt-dot ggt-dot--late" /><span className="ggt-link" />
          <span className="ggt-dot ggt-dot--pending" /><span className="ggt-link" />
          <span className="ggt-dot ggt-dot--pending" />
        </div>
        <span className="ggt-doto ggt-login__strip-label">4/6 CHECKS · 1 CON RETRASO</span>
      </div>
    </div>
  </div>
);

export const LoginArtMobile = () => (
  <div className="ggt-login__art-mobile d-lg-none">
    <svg aria-hidden="true" viewBox="0 0 390 360" preserveAspectRatio="xMidYMid slice" className="ggt-login__svg">
      <defs>
        <pattern id="ggt-m-dots" width="7" height="7" patternUnits="userSpaceOnUse"><circle cx="3.5" cy="3.5" r="1.3" fill="#363940" /></pattern>
        <pattern id="ggt-m-grid" width="14" height="14" patternUnits="userSpaceOnUse"><circle cx="7" cy="7" r=".8" fill="#24262b" /></pattern>
        <pattern id="ggt-m-dotsY" width="6" height="6" patternUnits="userSpaceOnUse"><circle cx="3" cy="3" r="2" fill="#ffc701" /></pattern>
        <pattern id="ggt-m-blocks" width="65" height="60" patternUnits="userSpaceOnUse"><rect x="0" y="0" width="52" height="48" rx="4" fill="#fff" /></pattern>
        <mask id="ggt-m-city" maskUnits="userSpaceOnUse" x="0" y="0" width="390" height="360">
          <rect width="390" height="360" fill="url(#ggt-m-blocks)" />
        </mask>
        <mask id="ggt-m-pin" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="82">
          <path d={PIN_PATH} fill="#fff" />
          <circle cx="30" cy="29" r="10" fill="#000" />
        </mask>
      </defs>
      <rect width="390" height="360" fill="url(#ggt-m-grid)" />
      <rect y="66" width="390" height="294" fill="url(#ggt-m-dots)" mask="url(#ggt-m-city)" />

      <path d="M253.5 215 V234 H318.5 V114" fill="none" stroke="#5b5f68" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0 8" />
      <path className="ggt-march ggt-march--sm" d="M58.5 234 H123.5 V114 H253.5 V215" fill="none" stroke="#ffc701" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0 8" />
      <path d="M253.5 150 V198" fill="none" stroke="#ff5a36" strokeWidth="4.5" strokeLinecap="round" strokeDasharray="0 8" />

      <g>
        <circle cx="58.5" cy="234" r="8" fill="#ffc701" />
        <Check x={58.5} y={234} s={0.6} w={1.8} />
        <circle cx="123.5" cy="174" r="8" fill="#ffc701" />
        <Check x={123.5} y={174} s={0.6} w={1.8} />
        <circle cx="188.5" cy="114" r="8" fill="#ffc701" />
        <Check x={188.5} y={114} s={0.6} w={1.8} />
        <circle className="ggt-pulse" cx="253.5" cy="174" r="17" fill="none" stroke="#ff5a36" strokeWidth="2.2" strokeDasharray="0 6" strokeLinecap="round" />
        <circle cx="253.5" cy="174" r="8" fill="#ff5a36" />
        <Check x={253.5} y={174} s={0.6} w={1.8} stroke="#ffffff" />
        <circle cx="318.5" cy="234" r="8" fill="#101113" stroke="#8b8e96" strokeWidth="2.2" strokeDasharray="0 4.5" strokeLinecap="round" />
      </g>

      <circle cx="253.5" cy="215" r="13" fill="#f1f1f2" opacity=".14" />
      <circle cx="253.5" cy="215" r="6" fill="#f1f1f2" />
      <circle cx="253.5" cy="215" r="2.3" fill="#101113" />

      <circle className="ggt-pulse" cx="318.5" cy="116" r="20" fill="none" stroke="#ffc701" strokeWidth="2.2" strokeDasharray="0 6" strokeLinecap="round" />
      <g transform="translate(300.5 65) scale(.6)"><rect width="60" height="82" fill="url(#ggt-m-dotsY)" mask="url(#ggt-m-pin)" /></g>

      <g fontFamily="Doto, monospace" fontWeight="700" letterSpacing=".5" fontSize="11">
        <rect x="20" y="246" width="110" height="22" rx="11" fill="#1f1b0c" stroke="#6b5600" />
        <text x="31" y="261" fill="#ffe17a">SALIDA 08:00</text>
        <rect x="30" y="163" width="80" height="22" rx="11" fill="#1f1b0c" stroke="#6b5600" />
        <text x="41" y="178" fill="#ffe17a">P1 08:24</text>
        <rect x="148" y="80" width="80" height="22" rx="11" fill="#1f1b0c" stroke="#6b5600" />
        <text x="159" y="95" fill="#ffe17a">P2 08:51</text>
        <rect x="140" y="163" width="101" height="22" rx="11" fill="#2a1612" stroke="#7a2e1f" />
        <circle className="ggt-blink" cx="152" cy="174" r="3" fill="#ff5a36" />
        <text x="160" y="178" fill="#ffb4a3">P3 +12 MIN</text>
        <rect x="274" y="246" width="88" height="22" rx="11" fill="#18191c" stroke="#3a3c42" strokeDasharray="3 3" />
        <text x="285" y="261" fill="#b4b6bc">ETA 09:58</text>
        <rect x="258" y="32" width="117" height="22" rx="11" fill="#ffc701" />
        <text x="269" y="47" fill="#101113">DESTINO 10:20</text>
      </g>
    </svg>

    <div className="ggt-login__brand-mobile">
      <LoginPin id="ggt-logo-m" width={20} height={27} />
      <span><b>GoGo</b> Logistic</span>
    </div>
  </div>
);
